export default __webpack_public_path__ + "static/media/travel-benefits.59e78eec.svg";